import _extends from 'babel-runtime/helpers/extends';

import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import LanguageSelector from './language-selector.vue';

export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    LanguageSelector: LanguageSelector
  },
  computed: _extends({}, mapGetters(['sidebar', 'name'])),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('ToggleSideBar');
      // 收起动画执行0.28秒
      setTimeout(function () {
        var event = document.createEvent('HTMLEvents');
        event.initEvent('resize', true, false);
        document.dispatchEvent(event);
      }, 300);
    },
    logout: function logout() {
      this.$store.dispatch('LogOut');
    }
  }
};